import { render } from "./OrangeFilledButton.vue?vue&type=template&id=474ee220&scoped=true"
import script from "./OrangeFilledButton.vue?vue&type=script&lang=js"
export * from "./OrangeFilledButton.vue?vue&type=script&lang=js"

import "./OrangeFilledButton.vue?vue&type=style&index=0&id=474ee220&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-474ee220"]])

export default __exports__